import { PanelNotice } from '@/modules/assistant/parts/panel-notice';
import { describeAssistantFailure } from '@/modules/assistant/shared/assistant-error';

export type PanelNoticesProps = {
  /** The failure of the route-aware context read. */
  contextError: unknown;
  /** The failure of the conversation-history read. */
  threadsError: unknown;
  /** The failure of the last turn. */
  sendError: unknown;
};

/**
 * The failures the person has to read, above the conversation.
 *
 * Each failure is rendered on its own: two different failures are two different
 * problems, and merging them into one sentence would name a reason the server
 * did not give.
 */
export function PanelNotices({ contextError, threadsError, sendError }: PanelNoticesProps) {
  const failures = [contextError, threadsError, sendError]
    .filter((failure): failure is unknown => failure !== null && failure !== undefined)
    .map((failure) => describeAssistantFailure(failure));

  if (failures.length === 0) return null;

  return (
    <>
      {failures.map((failure, index) => (
        <PanelNotice key={index} message={failure} />
      ))}
    </>
  );
}
